import { DeliveryStatus } from 'commons'

export const canSendReminderUtils = (deliveryStatus?: string, sentDate?: Date): boolean => {
  if (!deliveryStatus || !sentDate) {
    return true
  }
  switch (deliveryStatus) {
    case DeliveryStatus.SPAM:
    case DeliveryStatus.INEXISTENTE:
    case DeliveryStatus.SUPRIMIDO:
      return false

    case DeliveryStatus.RECHAZADO:
      return true

    default:
      return isOlderThan24Hours(sentDate)
  }
}

const isOlderThan24Hours = (date: Date | string | number): boolean => {
  const sentDate = date instanceof Date ? date : new Date(date)
  const ONE_DAY_MS = 24 * 60 * 60 * 1000
  return Date.now() - sentDate.getTime() >= ONE_DAY_MS
}
